module.exports = __webpack_public_path__ + "media/packs/images/flags/HK-8bdea4099b9ab1a864121c4a3cdcf391.png";